<p-button
    class="btn-primary"
    (onClick)="onClick()"
    [pTooltip]="tooltip"
    icon="pi pi-plus"
    [label]="label"
    tooltipPosition="left">
</p-button>